import { RefObject, useEffect } from "react";

/** Calls `onDismiss` on a click outside `ref` or on Escape, while `active`. */
export const useDismissable = (
  ref: RefObject<HTMLElement>,
  active: boolean,
  onDismiss: () => void
) => {
  useEffect(() => {
    if (!active) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onDismiss();
      }
    };
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onDismiss();
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [ref, active, onDismiss]);
};
